module.exports = __webpack_public_path__ + "static/media/icon_manage-entries.22c6cd35.svg";